import React from "react";
import { batch, useDispatch } from "react-redux";
import { user as userFlagFn } from "../../../services/flags/api";
import { setUser as setUserFlags } from "../../../state/flags";
import { setUser } from "../../../state/user";
import Presentation from "./Presentation";
var Login = function(param) {
    var title = param.title, loginFn = param.loginFn, _param_afterLogin = param.afterLogin, afterLogin = _param_afterLogin === void 0 ? null : _param_afterLogin, _param_redirectUrl = param.redirectUrl, redirectUrl = _param_redirectUrl === void 0 ? "/" : _param_redirectUrl;
    var dispatch = useDispatch();
    return /*#__PURE__*/ React.createElement(Presentation, {
        title: title,
        userFlagFn: userFlagFn,
        loginFn: loginFn,
        redirectUrl: redirectUrl,
        setUserAndFlags: function(user, flags) {
            return batch(function() {
                dispatch(setUser(user));
                dispatch(setUserFlags(flags));
            });
        },
        afterLogin: afterLogin
    });
};
export default Login;
